import ApiService from '@/core/services/ApiService'
import SystemService from '@/core/services/SystemService'
import helper from '@/utils/helper'

export default {
  // namespaced: true,
  state() {
    return {
      menus: [],
    }
  },
  mutations: {
    setMenus(state, payload) {
      state.menus = payload
    },
  },
  actions: {
    async loadMenus(context) {
      let appId = SystemService.getAppKey()
      if (!appId) {
        appId = '0'
      }
      await ApiService.get('Home/getUserMenu/' + appId).then(({ data }) => {
        const constMenu = [
          {
            pages: [
              {
                heading: 'Нүүр',
                route: '/dashboard',
                svgIcon: 'media/icons/duotune/art/art002.svg',
                fontIcon: 'bi-app-indicator',
              },
            ],
          },
        ]
        const ddd = helper.listTreeId(data, true, 0)
        constMenu[0].pages.push(...ddd)

        context.commit('setMenus', constMenu)
        // rout
      })
    },
  },
  getters: {
    getMenus(state) {
      return state.menus
    },
  },
}
